import { Box, Button, Select, MenuItem, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CommonFunction } from 'src/utils/commonFunctions/common-function.component';
import { useTranslation } from 'react-i18next';

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: '0.875rem',
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.light,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
}));

const ProfileSelector = ({ profiles, selectedProfile, onProfileChange, onNavCRMAccounts, isMobile }) => {
  const { t: translate } = useTranslation();
  return (
    <Box
      sx={{
        mb: 3,
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'flex-start' : 'center',
        gap: isMobile ? 1 : 2,
      }}
    >
      <Select
        size="small"
        value={selectedProfile?.id || ''}
        onChange={(e) => onProfileChange(e.target.value)}
        displayEmpty
        sx={{
          width: isMobile ? '100%' : 450,
          bgcolor: 'background.paper',
          borderRadius: 1,
        }}
        renderValue={(selected) =>
          selected ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {CommonFunction.InitialAccountBadgeWithName(
                profiles.find((profile) => profile.id === selected),
                24
              )}
            </Box>
          ) : (
            <Typography color="text.secondary" sx={{ fontSize: '0.875rem' }}>
              {translate('profile_selector.select_source_profile', 'Select a Source Profile')}
            </Typography>
          )
        }
      >
        {profiles
          .filter((profile) => profile.service_name === 'instagram' || profile.service_name === 'facebook')
          .map((profile) => (
            <StyledMenuItem
              key={profile.id}
              value={profile.id}
              sx={{
                pointerEvents: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: isMobile ? '100%' : 450,
              }}
            >
              <Box sx={{ opacity: profile.is_enabled ? 1 : 0.5, flex: 1 }}>
                {CommonFunction.InitialAccountBadgeWithName(profile, 24)}
              </Box>
              {!profile.is_enabled && (
                <Button
                  variant="contained"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    onNavCRMAccounts();
                  }}
                  sx={{
                    ml: 2,
                    bgcolor: 'error.main',
                    color: 'error.contrastText',
                    '&:hover': { bgcolor: 'error.dark' },
                    fontSize: '0.75rem',
                    px: 2,
                    py: 0.5,
                  }}
                >
                  {translate('profile_selector.enable', 'Enable')}
                </Button>
              )}
            </StyledMenuItem>
          ))}
      </Select>
    </Box>
  );
};

export default ProfileSelector;
